import {cn} from '@containers/html-utils'
import {observer} from 'mobx-react-lite'
import React from 'react'
import {TaskWithColor} from '../../calendar-store'
import {TaskContent} from './task-content'

export const TaskWithStartDate = observer(
  ({
    task,
    drag = false,
    top,
    height,
    showBottomDeadline = false,
    hideDeadline = false,
    timeWithDate = false,
    className = '',
    customTop,
    textOpacity,
    changeDeadlineExpansion = false,
    pointerEventsNone,
    allDay
  }: {
    task: TaskWithColor
    drag?: boolean
    top: number
    height: number
    showBottomDeadline?: boolean
    hideDeadline?: boolean
    className?: string
    customTop?: number
    textOpacity?: string
    timeWithDate?: boolean
    changeDeadlineExpansion?: boolean
    pointerEventsNone: boolean
    allDay: boolean
  }) => {
    return (
      <>
        <TaskContent
          allDay={allDay}
          customTop={customTop}
          task={task}
          className={cn(
            className,
            'absolute z-10 min-h-30',
            pointerEventsNone && 'pointer-events-none'
          )}
          top={top}
          height={height}
          drag={drag}
          type="with-start-date"
          showBottomDeadline={showBottomDeadline}
          hideDeadline={hideDeadline}
          textOpacity={textOpacity}
          timeWithDate={timeWithDate}
          changeDeadlineExpansion={changeDeadlineExpansion}
        />
      </>
    )
  }
)
